@if (menuItems().length > 0) {
  <div class="context-menu" cdkMenu>
    <hlm-dropdown-menu-sub>
      @for (item of menuItems(); track item.label) {
        <button
          [hlmDropdownMenuTrigger]="item.children?.length ? invite : null"
          [hlmDropdownMenuTriggerData]="{ items: item.children }"
          (click)="item.action?.(data())"
          hlmDropdownMenuItem
          align="start"
          side="right"
        >
          <ng-icon [name]="item.icon" hlm size="sm" />
          {{ item.label }}

          @if (item.children?.length) {
            <hlm-dropdown-menu-item-sub-indicator />
          }
        </button>
      }
    </hlm-dropdown-menu-sub>
  </div>
}

<ng-template #invite let-items="items">
  <hlm-dropdown-menu-sub>
    @for (item of items; track $index) {
      @if (item.type === 'checkbox') {
        <button [checked]="item.checked" (triggered)="item.action?.(item)" hlmDropdownMenuCheckbox>
          <hlm-dropdown-menu-checkbox-indicator />
          <span>{{ item.label }}</span>
        </button>
      } @else {
        <button (click)="item.action?.(item)" hlmDropdownMenuItem>
          @if (item.icon) {
            <ng-icon [name]="item.icon" hlm size="sm" />
          }
          {{ item.label }}

          @if (item.children?.length) {
            <hlm-dropdown-menu-item-sub-indicator />
          }
        </button>
      }
    }
  </hlm-dropdown-menu-sub>
</ng-template>
